
(function(){
"use strict";
if (window.BRVisualizer) return;
var SCRIPT = document.currentScript;
var ENDPOINT = (window.BR_VISUALIZER && window.BR_VISUALIZER.endpoint) || (SCRIPT ? SCRIPT.src.split("?")[0] : "");
var MAX_IN = 10 * 1024 * 1024, MAX_EDGE = 2048, MAX_SEND = 4.2 * 1024 * 1024;
var STEPS = ["Nahrávám fotku…","Měřím prostor a strop…","Vybírám nejlepší místo…","Stavím regál…","Ladím světlo a stíny…","Přidávám poslední detaily…"];

(function(){ if (document.getElementById("brv-css")) return;
  var l = document.createElement("link"); l.id = "brv-css"; l.rel = "stylesheet"; l.href = ENDPOINT + "?asset=widget.css"; document.head.appendChild(l); })();

function h(tag, attrs, kids){ var n = document.createElement(tag); attrs = attrs || {};
  for (var k in attrs){ var v = attrs[k]; if (v == null) continue;
    if (k === "cls") n.className = v; else if (k === "text") n.textContent = v; else if (k === "html") n.innerHTML = v;
    else if (k.indexOf("on") === 0) n.addEventListener(k.slice(2), v); else n.setAttribute(k, v); }
  (kids || []).forEach(function(c){ if (c) n.appendChild(typeof c === "string" ? document.createTextNode(c) : c); });
  return n; }
function kc(haler){ return Math.round(haler / 100).toLocaleString("cs-CZ") + " Kč"; }

function shrink(file){ return new Promise(function(res, rej){
  var u = URL.createObjectURL(file), im = new Image();
  im.onload = function(){ var s = Math.min(1, MAX_EDGE / Math.max(im.naturalWidth, im.naturalHeight));
    var c = document.createElement("canvas"); c.width = Math.round(im.naturalWidth * s); c.height = Math.round(im.naturalHeight * s);
    c.getContext("2d").drawImage(im, 0, 0, c.width, c.height); URL.revokeObjectURL(u);
    c.toBlob(function(b){ b ? res(b) : rej(new Error("enc")); }, "image/jpeg", 0.88); };
  im.onerror = function(){ URL.revokeObjectURL(u); rej(new Error("heic")); };
  im.src = u; }); }

function addToCart(buy){
  try {
    if (window.BRStorefront && typeof window.BRStorefront.addToCart === "function"){
      var r = window.BRStorefront.addToCart(buy.code, buy.qty);
      return Promise.resolve(r).then(function(added){ if (added === false) throw new Error("cart"); return "cart"; });
    }
  } catch (e) {}
  var ev; try { ev = new CustomEvent("br:add-to-cart", { detail: { code: buy.code, quantity: buy.qty, variantId: buy.variantId, handled: false }, cancelable: true }); document.dispatchEvent(ev); } catch (e) {}
  if (ev && (ev.defaultPrevented || ev.detail.handled)) return Promise.resolve("cart");
  window.location.href = buy.url; return Promise.resolve("page");
}

// Deferred owned modal CSS: never mount an unstyled dialog on an early click.
function waitForVisualizerCSS(){
  var link = document.getElementById("brv-css");
  if (!link || link.dataset.brvDeferred !== "true") return Promise.resolve();
  if (link.dataset.brError === "true") return Promise.reject(new Error("css"));
  if (link.sheet || link.dataset.brLoaded === "true") { link.media = "all"; return Promise.resolve(); }
  return new Promise(function(resolve, reject){
    var done = false, timer;
    function finish(error){ if (done) return; done = true; clearTimeout(timer);
      link.removeEventListener("load", loaded); link.removeEventListener("error", failed);
      if (error) reject(new Error("css")); else { link.media = "all"; resolve(); } }
    function loaded(){ finish(false); } function failed(){ finish(true); }
    link.addEventListener("load", loaded); link.addEventListener("error", failed);
    timer = setTimeout(failed, 8000);
    // Recheck after listeners to cover load completing between initial check and bind.
    if (link.sheet || link.dataset.brLoaded === "true") loaded();
    else if (link.dataset.brError === "true") failed();
  });
}
var openGeneration = 0, cssStatus = null, pendingEscape = null;
function removeCSSStatus(){ if (pendingEscape) { document.removeEventListener("keydown", pendingEscape); pendingEscape = null; } if (cssStatus) { cssStatus.remove(); cssStatus = null; } }
function requestOpen(opts){
  var link = document.getElementById("brv-css");
  // Preserve immediate existing flow when CSS is already usable: no status flash.
  if (!link || link.dataset.brvDeferred !== "true" || (link.dataset.brError !== "true" && (link.sheet || link.dataset.brLoaded === "true"))) {
    if (link) link.media = "all";
    removeCSSStatus(); open(opts); return Promise.resolve();
  }
  var generation = ++openGeneration;
  removeCSSStatus();
  cssStatus = h("div", { role: "status", style: "position:fixed;bottom:24px;left:16px;right:16px;z-index:2147483001;padding:16px;background:#fff;color:#17202c;border:1px solid #ded8ce;border-radius:12px;font:16px Arial,sans-serif", text: "Načítáme vizualizaci…" });
  document.body.appendChild(cssStatus);
  pendingEscape = function(e){ if (e.key === "Escape") close(); };
  document.addEventListener("keydown", pendingEscape);
  return waitForVisualizerCSS().then(function(){
    if (generation !== openGeneration) return;
    removeCSSStatus(); open(opts);
  }, function(){
    if (generation !== openGeneration) return;
    removeCSSStatus();
    cssStatus = h("div", { role: "alert", style: "position:fixed;bottom:24px;left:16px;right:16px;z-index:2147483001;padding:16px;background:#fff;color:#17202c;border:1px solid #ded8ce;border-radius:12px;font:16px Arial,sans-serif", text: "Vizualizaci se nepodařilo načíst. Zkuste to prosím znovu." });
    document.body.appendChild(cssStatus);
    setTimeout(function(){ if (generation === openGeneration) removeCSSStatus(); }, 5000);
  });
}
// End deferred modal CSS gate.

var ov = null, escH = null;
function close(){ ++openGeneration; removeCSSStatus(); if (ov){ ov.remove(); ov = null; document.documentElement.classList.remove("brv-lock"); }
  if (escH){ document.removeEventListener("keydown", escH); escH = null; } }

function open(opts){
  close();
  var st = { sku: opts.sku, handle: opts.handle || null, title: opts.title || "", file: null, hint: null, timer: null };
  var body = h("div");
  var dlg = h("div", { cls: "brv-dlg", role: "dialog", "aria-modal": "true", "aria-label": "Vyzkoušet u mě doma" },
    [h("button", { cls: "brv-x", type: "button", "aria-label": "Zavřít", text: "×", onclick: close }), body]);
  ov = h("div", { cls: "brv-ov", onclick: function(e){ if (e.target === ov) close(); } }, [dlg]);
  escH = function(e){ if (e.key === "Escape") close(); }; document.addEventListener("keydown", escH);
  document.body.appendChild(ov); document.documentElement.classList.add("brv-lock");
  function view(nodes){ body.innerHTML = ""; nodes.forEach(function(n){ if (n) body.appendChild(n); }); dlg.scrollTop = 0; }

  function intro(err){
    var cam = h("input", { type: "file", accept: "image/*", capture: "environment", cls: "brv-file" });
    var gal = h("input", { type: "file", accept: "image/jpeg,image/png,image/webp,image/heic,image/heif", cls: "brv-file" });
    function pick(inp){ var f = inp.files && inp.files[0]; if (!f) return;
      if (f.size > MAX_IN){ intro("Fotka je větší než 10 MB. Vyberte prosím menší."); return; }
      st.file = f; st.hint = null; place(); }
    cam.addEventListener("change", function(){ pick(cam); }); gal.addEventListener("change", function(){ pick(gal); });
    view([
      h("h2", { cls: "brv-h", text: "Vyzkoušejte regál u sebe" }),
      h("p", { cls: "brv-sub", text: st.title }),
      h("ul", { cls: "brv-tips" }, [
        h("li", {}, [h("b", { text: "1" }), "Postavte se 2–3 m od místa, kam chcete regál dát."]),
        h("li", {}, [h("b", { text: "2" }), "Foťte ideálně na šířku, ať je vidět podlaha, stěna i strop."]),
        h("li", {}, [h("b", { text: "3" }), "Náhled uvidíte hned, vizualizaci v plném rozlišení odemknete e-mailem."])
      ]),
      h("div", { cls: "brv-btns" }, [
        h("label", { cls: "brv-btn brv-pri" }, [cam, "📷 Vyfotit teď"]),
        h("label", { cls: "brv-btn brv-sec" }, [gal, "Vybrat z galerie"])
      ]),
      err ? h("p", { cls: "brv-err", text: err }) : null,
      h("p", { cls: "brv-legal", text: "Orientační vizualizace vytvořená umělou inteligencí. Fotku neukládáme, výsledek se po 7 dnech smaže." })
    ]);
  }

  function place(err){
    var url = URL.createObjectURL(st.file);
    var dot = h("div", { cls: "brv-dot", style: "display:none" });
    var im = h("img", { src: url, alt: "Vaše fotka" });
    var box = h("div", { cls: "brv-photo" }, [im, dot]);
    function mark(){ if (!st.hint){ dot.style.display = "none"; return; }
      var r = im.getBoundingClientRect(), b = box.getBoundingClientRect();
      dot.style.display = "block"; dot.style.left = (r.left - b.left + st.hint.x * r.width) + "px"; dot.style.top = (r.top - b.top + st.hint.y * r.height) + "px"; }
    box.addEventListener("click", function(e){ var r = im.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      if (x < 0 || x > 1 || y < 0 || y > 1) return; st.hint = { x: x, y: y }; mark(); });
    im.onload = mark;
    im.onerror = function(){ box.innerHTML = ""; box.appendChild(h("p", { cls: "brv-note", text: "Náhled fotky nelze zobrazit, zkusíme ji přesto zpracovat." })); };
    var ok = h("input", { type: "checkbox" });
    var go = h("button", { type: "button", cls: "brv-btn brv-pri", text: "Vytvořit vizualizaci" });
    var errEl = h("p", { cls: "brv-err", text: err || "" });
    go.addEventListener("click", function(){
      if (!ok.checked){ errEl.textContent = "Pro pokračování prosím potvrďte souhlas se zpracováním fotky."; return; }
      run(); });
    view([
      h("h2", { cls: "brv-h", text: "Kam regál dáme?" }),
      box,
      h("p", { cls: "brv-hint", text: "Klepněte na místo, kam chcete regál postavit. Nepovinné — jinak vybereme nejvhodnější volnou stěnu." }),
      h("label", { cls: "brv-chk" }, [ok, h("span", { html: "Souhlasím se zpracováním fotky pro vytvoření vizualizace. Fotku neukládáme, výsledek se smaže po 7 dnech. <a href=\"/policies/privacy-policy\" target=\"_blank\" rel=\"noopener\">Více</a>" })]),
      go, errEl,
      h("button", { type: "button", cls: "brv-btn brv-sec", style: "margin-top:10px", text: "Vybrat jinou fotku", onclick: function(){ intro(); } })
    ]);
  }

  function run(){
    var stepEl = h("div", { cls: "brv-step", text: STEPS[0] }), bar = h("i");
    view([h("div", { cls: "brv-prog" }, [h("div", { cls: "brv-spin" }), stepEl, h("div", { cls: "brv-small", text: "Obvykle 20–40 sekund. Okno prosím nezavírejte." }), h("div", { cls: "brv-bar" }, [bar])])]);
    var i = 0, t0 = Date.now();
    st.timer = setInterval(function(){ i = Math.min(i + 1, STEPS.length - 1); stepEl.textContent = STEPS[i];
      bar.style.width = Math.min(92, (Date.now() - t0) / 350) + "%"; }, 5000);
    setTimeout(function(){ bar.style.width = "6%"; }, 50);
    shrink(st.file).catch(function(){ if (st.file.size <= MAX_SEND) return st.file; throw new Error("heic"); })
    .then(function(b){ if (b.size > MAX_SEND) throw new Error("big");
      var fd = new FormData(); fd.append("photo", b, "room.jpg"); fd.append("sku", st.sku); fd.append("consent", "yes");
      if (st.handle) fd.append("handle", st.handle);
      if (st.hint){ fd.append("hint_x", st.hint.x.toFixed(3)); fd.append("hint_y", st.hint.y.toFixed(3)); }
      return fetch(ENDPOINT, { method: "POST", body: fd, credentials: "omit" }); })
    .then(function(r){ return r.json(); })
    .then(function(b){ clearInterval(st.timer); bar.style.width = "100%";
      if (!b || !b.ok) throw new Error((b && b.message) || "Vizualizaci se nepodařilo vytvořit.");
      teaser(b); })
    .catch(function(e){ clearInterval(st.timer); var m = e && e.message;
      if (m === "heic") m = "Tento formát fotky prohlížeč neumí zpracovat. Uložte ji prosím jako JPG.";
      else if (m === "big") m = "Fotka je příliš velká. Zkuste prosím menší.";
      else if (!m || m === "Failed to fetch" || m === "Load failed") m = "Spojení se nezdařilo. Zkuste to prosím znovu.";
      place(m); });
  }

  function siteHeader(){
    var source = document.querySelector(".brp-header");
    if (!source) return null;
    var header = source.cloneNode(true);
    header.className = "brv-site-header";
    header.querySelectorAll("button,a").forEach(function(n){ n.removeAttribute("data-route"); n.removeAttribute("data-action"); n.removeAttribute("href"); n.setAttribute("tabindex", "-1"); });
    return header;
  }

  function teaser(b){
    var mail = h("input", { cls: "brv-in", type: "email", inputmode: "email", autocomplete: "email", placeholder: "váš@e-mail.cz", "aria-label": "E-mail" });
    var mk = h("input", { type: "checkbox" });
    var send = h("button", { type: "button", cls: "brv-btn brv-pri", text: "Odemknout vizualizaci" });
    var errEl = h("p", { cls: "brv-err" });
    send.addEventListener("click", function(){
      var v = (mail.value || "").trim();
      if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(v)){ errEl.textContent = "Zkontrolujte prosím e-mailovou adresu."; mail.focus(); return; }
      send.disabled = true; send.textContent = "Odemykám…"; errEl.textContent = "";
      fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "text/plain" }, credentials: "omit",
        body: JSON.stringify({ action: "unlock", id: b.id, email: v, marketing: mk.checked }) })
      .then(function(r){ return r.json(); })
      .then(function(r){ if (!r.ok) throw new Error(r.message || "Vizualizaci se nepodařilo odemknout."); reveal(r, v, b); })
      .catch(function(e){ send.disabled = false; send.textContent = "Odemknout vizualizaci";
        errEl.textContent = (e && e.message && e.message !== "Failed to fetch") ? e.message : "Spojení se nezdařilo. Zkuste to prosím znovu."; });
    });
    var p = b.product || {};
    var unlock = h("div", { cls: "brv-unlock" }, [
      h("strong", { text: "Zadejte e-mail a vizualizaci vám odemkneme" }),
      h("span", { text: "Kopii vám pošleme také do e-mailu." }),
      mail, send,
      h("label", { cls: "brv-chk" }, [mk, h("span", { text: "Chci dostávat slevy a novinky Bazarovyregal.cz e-mailem (nepovinné)." })]),
      errEl
    ]);
    var preview = h("div", { cls: "brv-prev" }, [h("img", { src: b.preview, alt: "Rozmazaný náhled vizualizace" }), unlock]);
    view([
      siteHeader(),
      h("h2", { cls: "brv-h", text: "Vizualizace je připravená ✓" }),
      b.warning ? h("p", { cls: "brv-warn", text: b.warning }) : null,
      preview,
      h("p", { cls: "brv-legal", text: b.disclaimer })
    ]);
  }

  function reveal(r, email, b){
    var p = r.product || {}, buy = r.buy || {};
    var catalogUnverified = r.catalogState === "unverified";
    var save = !catalogUnverified && buy.compareHaler && buy.compareHaler > buy.priceHaler ? buy.compareHaler - buy.priceHaler : 0;
    var buyBtn = h("button", { type: "button", cls: "brv-btn brv-pri", text: catalogUnverified ? "Ověřit cenu a dostupnost" : (buy.count > 1 ? "Přidat " + buy.count + " ks do košíku" : "Přidat do košíku") + " – " + kc(buy.priceHaler) });
    buyBtn.addEventListener("click", function(){ if (catalogUnverified) { window.location.href = p.url || buy.url; return; } buyBtn.disabled = true; buyBtn.textContent = "Přidávám…";
      addToCart(buy).then(function(where){ if (where === "cart"){ buyBtn.textContent = "✓ V košíku"; setTimeout(close, 900); } }).catch(function(){ buyBtn.disabled = false; buyBtn.textContent = "Nepodařilo se přidat. Zkusit znovu"; }); });
    var rows = [["Rozměry (V × Š × H)", p.heightCm + " × " + p.widthCm + " × " + p.depthCm + " cm"],
      ["Počet polic", p.shelves || "–"],
      ["Nosnost", p.loadShelfKg && p.loadTotalKg ? p.loadShelfKg + " kg na polici, celkem " + p.loadTotalKg + " kg" : (p.loadTotalKg ? p.loadTotalKg + " kg" : "–")],
      ["Provedení", [p.surface, p.colour].filter(Boolean).join(", ") || "–"],
      ["Záruka", p.warrantyYears ? p.warrantyYears + " let" : "Viz aktuální detail produktu"],
      ["Dostupnost", "Aktuální dostupnost ověřte na e-shopu"]];
    var specs = h("table", { cls: "brv-specs" }, [h("tbody", {}, rows.map(function(rw){ return h("tr", {}, [h("td", { text: rw[0] }), h("td", { text: String(rw[1]) })]); }))]);
    var alts = (r.alternatives || []).map(function(a){
      return h("a", { cls: "brv-alt", href: a.url }, [h("img", { src: a.image + (a.image.indexOf("?") > -1 ? "&" : "?") + "width=400", alt: a.colour, loading: "lazy" }),
        h("span", { text: a.colour || "Jiná barva" }), h("b", { text: kc(a.priceHaler) })]); });
    var resultImage = h("div", { cls: "brv-result" }, [
      h("img", { cls: "brv-full", src: r.imageUrl, alt: "Vizualizace regálu ve vašem prostoru" }),
      h("span", { cls: "brv-watermark", text: "Bazarovyregal.cz" })
    ]);
    var download = h("button", { type: "button", cls: "brv-action", text: "Stáhnout fotku" });
    download.addEventListener("click", function(){
      download.disabled = true; download.textContent = "Připravuji fotku…";
      fetch(r.imageUrl).then(function(res){ if (!res.ok) throw new Error("download"); return res.blob(); }).then(function(blob){
        var url = URL.createObjectURL(blob), a = document.createElement("a");
        a.href = url; a.download = "bazarovyregal-vizualizace.jpg"; document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function(){ URL.revokeObjectURL(url); }, 60000);
        download.textContent = "Stáhnout fotku";
      }).catch(function(){ download.textContent = "Stažení selhalo. Zkusit znovu"; }).finally(function(){ download.disabled = false; });
    });
    var share = h("button", { type: "button", cls: "brv-action", text: "Sdílet fotku" });
    var copyOffered = false;
    share.addEventListener("click", function(){
      var payload = { title: "Moje vizualizace regálu", text: "Podívejte se, jak může regál vypadat u mě doma.", url: r.imageUrl };
      function copied(){ copyOffered = false; share.textContent = "Odkaz zkopírován"; setTimeout(function(){ share.textContent = "Sdílet fotku"; }, 1800); }
      function failed(){ share.textContent = "Sdílení selhalo. Zkusit znovu"; }
      function copyLink(){
        if (!navigator.clipboard || !navigator.clipboard.writeText) { share.textContent = "Otevřete fotku a zkopírujte odkaz"; return; }
        share.disabled = true;
        navigator.clipboard.writeText(r.imageUrl).then(copied, function(){ share.textContent = "Kopírování selhalo. Zkusit znovu"; }).finally(function(){ share.disabled = false; });
      }
      if (copyOffered) { copyLink(); return; }
      if (navigator.share) {
        navigator.share(payload).catch(function(err){ if (!err || err.name !== "AbortError") { copyOffered = true; share.textContent = "Zkopírovat odkaz"; } });
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(r.imageUrl).then(copied, failed);
      } else { share.textContent = "Otevřete fotku a zkopírujte odkaz"; }
    });
    var actions = h("div", { cls: "brv-actions" }, [download, share, buyBtn]);
    var dim = [p.heightCm, p.widthCm, p.depthCm].filter(Boolean).join(" × ");
    view([
      siteHeader(),
      h("h2", { cls: "brv-h", text: "Sluší mu to u vás, že? 🙂" }),
      resultImage,
      h("p", { cls: "brv-caption", text: "Orientační vizualizace regálu " + (dim || "") + " cm" }),
      actions,
      h("p", { cls: "brv-legal", style: "margin-top:0", text: b.disclaimer }),
      h("div", { cls: "brv-price" }, [h("b", { text: catalogUnverified ? "Aktuální cena a dostupnost nejsou ověřené" : kc(buy.priceHaler) }), save ? h("s", { text: kc(buy.compareHaler) }) : null,
        save ? h("div", {}, [h("em", { text: "Ušetříte " + kc(save) })]) : null,
        h("small", { text: buy.count > 1 ? (buy.qty === 1 ? "balení " + buy.count + " ks" : buy.count + " ks") : "1 regál" })]),
      h("h3", { cls: "brv-h3", text: p.title }),
      specs,
      alts.length ? h("h3", { cls: "brv-h3", text: "Stejný regál v jiné barvě" }) : null,
      alts.length ? h("div", { cls: "brv-alts" }, alts) : null,
      h("div", { cls: "brv-usp" }, [h("div", {}, [h("b", { text: "40 000+" }), "regálů skladem v Brně"]),
        h("div", {}, [h("b", { text: "125" }), "variant regálů"]), h("div", {}, [h("b", { text: "Ihned" }), "expedujeme"])]),
      h("p", { cls: "brv-legal", text: r.message || "Vizualizace je odemčená. Stav odeslání e-mailu zatím není ověřený." }),
      h("button", { type: "button", cls: "brv-btn brv-sec", style: "margin-top:12px", text: "Zkusit jinou fotku", onclick: function(){ intro(); } })
    ]);
  }

  intro();
}

document.addEventListener("click", function(e){
  var t = e.target && e.target.closest ? e.target.closest("[data-br-visualize]") : null; if (!t) return;
  e.preventDefault();
  requestOpen({ sku: t.getAttribute("data-sku"), handle: t.getAttribute("data-handle"), title: t.getAttribute("data-title") });
});
window.BRVisualizer = { open: requestOpen, close: close };
})();
